import React from "react";
import "../styles/common.css";

export default function ComingSoonTag() {
	return (
		<div id="coming-soon">
			<p>Launching in 2024</p>
		</div>
	);
}
